import React from 'react';
import PropTypes from 'prop-types';

const Educations = ({ data }) => {
    if (!Array.isArray(data) || data.length === 0) {
        return null;
    }

    return (
        <>
            {data.map((education) => (
                <section key={education.id} className="education-entry">
                    <h3 className="text-5">
                        {`${education.name_of_degree} in ${education.title}`}
                    </h3>
                    <div className="mb-2 text-muted text-2 date-entry">
                        <span className="text-secondary">{education.course_duration}</span>
                    </div>
                    <p className="text-muted text-3">{education.college}</p>
                    <hr className="my-4" />
                </section>
            ))}
        </>
    );
};

Educations.propTypes = {
    data: PropTypes.arrayOf(
        PropTypes.shape({
            id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
            name_of_degree: PropTypes.string.isRequired,
            title: PropTypes.string.isRequired,
            course_duration: PropTypes.string,
            college: PropTypes.string,
        })
    ).isRequired,
};

export default Educations;
